var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12198 11.7581C0.737174 9.37327 0.737174 5.50675 3.12198 3.12194C5.50678 0.737143 9.3733 0.737143 11.7581 3.12194C13.9379 5.30178 14.1253 8.71959 12.3202 11.1122L14.7296 13.5217C15.3581 14.1502 14.4153 15.093 13.7868 14.4645L11.4061 12.0838C9.00691 14.1374 5.39274 14.0288 3.12198 11.7581ZM10.8153 4.06475C8.95119 2.20065 5.92889 2.20065 4.06478 4.06475C2.20068 5.92886 2.20068 8.95116 4.06478 10.8153C5.92889 12.6794 8.95119 12.6794 10.8153 10.8153C12.6794 8.95116 12.6794 5.92886 10.8153 4.06475Z",
    fill: "#002760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3d3e8e7d5c0a3be4e18631ffc72342a5.svg";
export { ForwardRef as ReactComponent };